import type { CityConfig } from "../city-template/types";

export const denverConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Denver",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "denver",
  route: "/cities/denver",
  title: "Emergency Passport Denver, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Denver, CO — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Denver business travelers, DIA passengers, outdoor adventurers, and Front Range families.",
  h1: "Emergency & Expedited Passport Services in Denver, CO",
  heroSubtitle: "DIA flight to Tokyo in two weeks? Ski trip to the Swiss Alps? Tech conference in Berlin? We help Denver residents — from LoDo executives to Cherry Creek families to Boulder tech workers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Denver%20Colorado%20skyline%20at%20golden%20hour%20with%20Rocky%20Mountains%20in%20the%20background%2C%20modern%20downtown%20skyscrapers%2C%20warm%20sunset%20light%20reflecting%20off%20glass%20buildings%2C%20clean%20and%20modern%20urban%20scene%20with%20mountain%20peaks%20visible%2C%20professional%20cityscape%20photography%2C%20cinematic%20wide%20angle%20view%2C%20no%20visible%20text%20or%20people%2C%20warm%20amber%20and%20orange%20tones%20with%20cool%20mountain%20blues&width=1800&height=700&seq=denver-hero-001&orientation=landscape",
  heroImageAlt: "Denver Colorado skyline at golden hour with Rocky Mountains in the background",
  geoPosition: "39.7392;-104.9903",
  geoPlacename: "Denver, Colorado",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial CO 80112",
    distance: "Located in Centennial — approximately 15 miles south of downtown Denver. Colorado's only passport agency.",
  },
  nearbyCitiesZips: [
    { name: "Downtown Denver", zips: "80202–80205" },
    { name: "Cherry Creek", zips: "80206, 80209" },
    { name: "Capitol Hill", zips: "80203, 80218" },
    { name: "Highlands", zips: "80211, 80212" },
    { name: "LoDo", zips: "80202, 80204" },
    { name: "Wash Park", zips: "80209, 80210" },
    { name: "Stapleton / Central Park", zips: "80207, 80238" },
    { name: "Lakewood", zips: "80214, 80215, 80226" },
    { name: "Aurora", zips: "80010–80014, 80017" },
    { name: "Thornton", zips: "80229, 80233, 80241" },
    { name: "Westminster", zips: "80030, 80031, 80035" },
    { name: "Arvada", zips: "80002–80004, 80005" },
    { name: "Boulder", zips: "80301–80310" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour DIA Emergency Processing", desc: "Reserved courier access to the Colorado Passport Agency in Aurora — as fast as 24 hours for Denver travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "DIA Airport Expertise", desc: "DIA is America's largest airport by land area and a United/Southwest hub. 215+ nonstop destinations including Tokyo, London, Frankfurt, and Reykjavik." },
    { icon: "ri-landscape-line", title: "Adventure & Outdoor Ready", desc: "Ski trips to the Alps, Patagonia treks, Himalayan expeditions — Denver's outdoor culture creates year-round international passport demand." },
    { icon: "ri-building-2-line", title: "Tech & Startup Corridor", desc: "Google, Apple, Amazon, Palantir, and 700+ startups in Denver-Boulder. Short-notice international meetings are the norm here." },
  ],
  internalLinks: [
    { name: "Fast passport services in Colorado Springs", route: "/colorado-springs" },
    { name: "Expedited passport in Boulder, CO", route: "/boulder" },
    { name: "Quick passport services in Fort Collins", route: "/fort-collins" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Fast Passport Center — Cheyenne, WY office", route: "/cities/cheyenne" },
  ],
  fpcOfficeAddress: "370 17th St, Denver, CO 80202",
  fpcOfficeNote: "Fast Passport Center now has a physical office in downtown Denver at 370 17th St — by appointment only. Our registered couriers also have direct access to the Colorado Passport Agency in Aurora, meaning you get faster results without the appointment wait. Denver residents can ship from any UPS Store, FedEx Office, or post office location across the Front Range. Prefer not to visit? Courier pickup and drop-off is available — we'll come to your home or office anywhere in the Denver metro. We also have a physical Fast Passport Center office at 2020 Carey Ave, Cheyenne, WY 82001 — about 1 hour 45 minutes north via I-25, serving the northern Front Range and southeastern Wyoming.",
  fpcOfficeDistance: "Downtown Denver — by appointment only. Courier pickup available throughout Denver, Boulder, Aurora, Lakewood, Thornton, Westminster, Arvada, and all Front Range communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Denver and the greater Front Range. From downtown Denver's LoDo and RiNo to the foothills suburbs of Golden and Morrison, from Cherry Creek to the northern suburbs of Thornton and Westminster — we serve all of Denver County, Jefferson County, Adams County, Arapahoe County, and Boulder County. As a registered courier with guaranteed submission availability at the Colorado Passport Agency, we handle the in-person submission so you don't have to.",
  nearbyCitiesIntro: "We serve Denver and all Front Range communities including Boulder, Aurora, Lakewood, Thornton, Westminster, Arvada, Littleton, Centennial, and Golden. We also serve travelers departing from Denver International Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Denver as simple as possible — with the efficiency and reliability Front Range executives, outdoor adventurers, and Colorado families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Denver travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Denver travelers encounter unique passport issues — everything from DIA same-day bookings to ski season timing to 6-month validity rules for Asian destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Denver travelers — from LoDo executives to Cherry Creek families to Boulder adventurers — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Denver, CO? Here are the most common ones we hear from Front Range travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  servicesIntro: "Whether you need a renewal before a DIA flight to Frankfurt, an emergency passport for a last-second ski trip to Switzerland, or a first-time passport for a Colorado family's first international vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "DIA flight to Tokyo in two days? Ski trip to Zermatt this weekend? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Denver-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Denver residents renew fast — no agency visit required for most renewals. Perfect for Front Range executives, Boulder tech workers, and Colorado families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Denver residents through every step — from LoDo to Cherry Creek to Boulder — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your DIA international connection or adventure trip isn't derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Colorado family vacation abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Denver professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Denver tech executives, startup founders, and adventure guides who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Front Range travelers through the process so your international itinerary or adventure trip stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Denver CO", description: "Urgent passport processing for Denver Colorado travelers with immediate departure needs from DIA." },
    { name: "Expedited Passport Renewal Denver CO", description: "Fast passport renewal for Denver Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Denver CO", description: "New passport application services for Denver Colorado residents applying for their first passport." },
    { name: "Child Passport Denver CO", description: "Minor passport services for Denver Colorado families with children under 16." },
    { name: "Name Change Passport Denver CO", description: "Passport name correction after marriage, divorce, or legal name changes for Denver residents." },
    { name: "Second Passport Denver CO", description: "Second passport services for Denver tech executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Rachel K.",
      location: "Cherry Creek, Denver",
      rating: 5,
      text: "My flight to London was in 4 days and my passport had expired. Fast Passport Center got me a new one in 48 hours. Saved my business trip completely.",
      service: "Emergency Passport",
    },
    {
      name: "Michael T.",
      location: "Highlands, Denver",
      rating: 5,
      text: "I needed to renew for a family ski trip to Switzerland. The process was smooth, they reviewed everything, and I had my passport in 5 days.",
      service: "Passport Renewal",
    },
    {
      name: "Jessica L.",
      location: "Boulder, CO",
      rating: 5,
      text: "Lost my passport the week before my honeymoon to Bali. They walked me through everything and got me a replacement in 36 hours. Incredible.",
      service: "Lost Passport",
    },
    {
      name: "David M.",
      location: "RiNo, Denver",
      rating: 5,
      text: "As a startup founder who travels internationally every month, I can't afford delays. Fast Passport Center has been my go-to for years. Reliable every single time.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "den-1",
      name: "Denver Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "951 20th St",
      city: "Denver",
      state: "CO",
      zip: "80202",
      phone: "(303) 296-0524",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Denver",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "den-2",
      name: "Cherry Creek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "245 S. Monaco Pkwy",
      city: "Denver",
      state: "CO",
      zip: "80224",
      phone: "(303) 321-0734",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2.5 miles from Cherry Creek Mall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "den-3",
      name: "Aurora Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16890 E. Alameda Pkwy",
      city: "Aurora",
      state: "CO",
      zip: "80017",
      phone: "(303) 360-6270",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.2 miles from Aurora Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular location for east Denver and Aurora residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "den-4",
      name: "Lakewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10799 W. Alameda Ave",
      city: "Lakewood",
      state: "CO",
      zip: "80226",
      phone: "(303) 989-0485",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Belmar Shopping District",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Accepts walk-ins but appointments preferred. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "den-5",
      name: "Westminster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6333 W. 120th Ave",
      city: "Westminster",
      state: "CO",
      zip: "80020",
      phone: "(303) 410-0620",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.0 miles from Westminster City Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for north Denver metro residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "den-6",
      name: "Denver County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "201 W. Colfax Ave",
      city: "Denver",
      state: "CO",
      zip: "80202",
      phone: "(720) 865-8400",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Civic Center Park",
      website: "https://www.denvergov.org/",
      websiteLabel: "Denver County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — in-person appointment at Aurora Passport Agency", fpc: "Most Denver travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "DIA-Specific Guidance", agency: "Generic — no DIA airport, ski season, or adventure travel expertise", fpc: "Full DIA/outdoor/corporate/Colorado knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming the Aurora Agency Takes Walk-Ins",
      description: "The Colorado Passport Agency in Aurora requires appointments even for emergencies. Many Denver residents arrive without an appointment and are turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Denver applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Ski Season Passport Timing",
      description: "Denver residents booking European ski trips in November-December often realize their passport expired over the summer. Peak ski season creates a surge in urgent requests — plan ahead or use expedited service.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Colorado families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Denver travelers booking to Japan, Southeast Asia, or Europe often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or favorite coffee shop." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Denver clients ship from home or office — no need to drive anywhere." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — as a registered courier, we handle the in-person submission at the Colorado Passport Agency so you don't have to." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Denver?", a: "We offer Denver-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 2–9 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Denver office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Denver post office or county clerk) if required, then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Denver address." },
    { q: "Where can I get a passport acceptance in Denver?", a: "Denver has acceptance facilities at many post offices (downtown, Cherry Creek, Aurora, Lakewood, Westminster) as well as the Denver County Clerk. We maintain an updated list of Denver-area facilities with hours, photo availability, and appointment options." },
    { q: "Does the Colorado Passport Agency handle walk-ins?", a: "The Colorado Passport Agency (located in Aurora) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without agency restrictions." },
    { q: "What is the best price for expedited passport service in Denver?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Can you help with passports for DIA international travel?", a: "Yes. DIA is one of the world's busiest international airports with 215+ nonstop destinations, and we regularly assist Denver travelers with expedited passports for international departures. We understand the Front Range corridor — from Boulder to Castle Rock — and can coordinate timelines around your departure." },
    { q: "How do ski season and outdoor adventure affect passport timing?", a: "Denver's outdoor culture creates unique passport patterns: European ski trips spike November-December, Patagonia treks peak September-October, and Himalayan expeditions book year-round. Each has different visa and validity requirements we help navigate." },
    { q: "Is Denver near a passport agency?", a: "The Colorado Passport Agency is located at 7245 S Havana Street Suite B-600, Centennial, CO 80112 — about 15–30 minutes from most Denver neighborhoods. However, it only serves travelers with life-or-death emergencies. For standard expedited needs, our courier channel is faster and more accessible." },
    { q: "Do you serve Boulder and the northern Front Range?", a: "Absolutely. Fast Passport Center serves all of the Denver-Boulder corridor including Boulder, Louisville, Superior, Longmont, Broomfield, and Lafayette. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What documents do Denver applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Denver-specific checklist." },
    { q: "Can I get a passport photo in Denver?", a: "Yes — many Denver CVS, Walgreens, UPS Stores, FedEx Office locations, and AAA offices offer passport photos. Photos must be 2x2 inches, white background, no glasses, neutral expression. We review your photos before submission." },
    { q: "How do I check my Denver passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Denver to final return shipping typically matches your chosen speed tier." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Denver Residents",
    intro: "Denver's unique position as the Mountain West's global gateway — anchored by America's largest airport — creates distinct passport timing challenges. Here's what Denver travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "DIA — Denver International Airport",
        subtitle: "America's largest airport by land area, United & Southwest hub",
        description: "DIA handles more than 77 million passengers annually with nonstop flights to Tokyo, London, Frankfurt, Reykjavik, Mexico City, and 215+ destinations worldwide. United Airlines' massive operation means Denver connects the Mountain West to virtually every international market. The airport's global reach creates regular passport urgencies — ski season bookings to the Alps, tech executives heading to Asia, and adventure travelers departing for Patagonia or Nepal on short notice.",
        tip: "DIA's international flights often require early morning arrivals (4:00–6:00 AM departures). If you're dealing with a last-minute passport emergency, factor in 45–60 minutes from most Denver neighborhoods to the terminal, plus security and international check-in time.",
      },
      {
        icon: "ri-landscape-line",
        title: "Ski Season & Mountain Adventure Travel",
        subtitle: "Swiss Alps, Canadian Rockies, Patagonia, Japan powder",
        description: "Denver's outdoor culture drives a massive volume of international adventure travel. November through February sees a surge in European ski trips to Switzerland, France, Austria, and Italy. Summer brings Patagonia treks, Himalayan expeditions, and New Zealand adventures. Each destination has unique passport validity and visa requirements — many Denver adventurers realize their passport expires mid-season.",
        tip: "Ski season bookings (November–February) and summer expedition bookings (May–July) create predictable passport demand spikes. Start your renewal 8+ weeks before these windows, or use our expedited courier service if you're inside the 6-week mark.",
      },
      {
        icon: "ri-building-2-line",
        title: "Tech Corridor & Startup Travel",
        subtitle: "Google, Amazon, Palantir, Slack, and 700+ startups in Denver-Boulder",
        description: "The Denver-Boulder corridor is one of America's fastest-growing tech hubs. Google's Boulder campus, Amazon's Denver Tech Center, Palantir's Colorado office, and hundreds of venture-backed startups create constant international travel demand. When a Series A founder gets invited to pitch in London, or an engineering lead needs to visit the Tokyo office — passport urgencies emerge that standard processing can't handle.",
        tip: "Tech travel often has 1–2 weeks of lead time — not enough for standard expedited. Keep a current passport even between trips. For frequent flyers, a second passport keeps your primary available for visa processing.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "University Study Abroad & Student Travel",
        subtitle: "CU Boulder, DU, MSU Denver, Colorado School of Mines, CSU",
        description: "Colorado's university system sends thousands of students abroad each year. CU Boulder alone has 400+ study abroad programs in 65+ countries. The acceptance-to-departure pipeline is often 6–10 weeks, requiring expedited processing to meet program start dates. Many students — especially first-generation college students — have never had passports and need full first-time application guidance.",
        tip: "CU Boulder, DU, and Mines students must visit an acceptance facility in person for first-time applications. We guide students to the nearest facility with the earliest available appointment so they don't miss their program orientation.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Denver & the Front Range Travel Corridor",
      description: "Denver International Airport serves a catchment area spanning 6 states — Wyoming, Nebraska, Kansas, New Mexico, and the Dakotas all funnel through DIA. Many travelers from these regions use Denver as their international gateway, and we regularly help ranchers, energy workers, and rural families from across the Mountain West coordinate passport timelines around DIA departures.",
    },
  },
  destinations: {
    title: "Where Denver Travelers Go — And Why Passports Get Urgent",
    intro: "DIA's global reach means Denver travelers need passports for destinations spanning six continents. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "45%", label: "of Denver expedited requests are adventure/outdoor travel-related with 3–6 weeks notice" },
      { stat: "2–4 Weeks", label: "average lead time Denver tech travelers have from meeting booking to international departure" },
      { stat: "Nov–Feb", label: "peak ski season when European Alps bookings collide with holiday travel demand" },
      { stat: "28 Hours", label: "shortest turnaround we have accommodated for a Denver startup founder departing to Berlin" },
    ],
    destinations: [
      { name: "Japan & South Korea", context: "United DIA-Tokyo nonstop, tech industry meetings, ski trips to Niseko and Hokkaido powder", urgency: "Tech travel booked 1–2 weeks out; ski season peaks December–February", icon: "ri-map-pin-2-line" },
      { name: "Switzerland & France", context: "DIA-Zurich connections, Swiss and French Alps ski destinations, Chamonix and Zermatt bookings", urgency: "Ski season bookings spike in October–November for December–February departures", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "DIA-London nonstop, tech and finance meetings, heritage travel for Irish-American community", urgency: "Business trips booked 2–3 weeks out with fixed meeting dates", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "DIA-Frankfurt nonstop, tech and engineering conferences, outdoor industry trade shows", urgency: "Industry conference dates are fixed and unmovable — ISPO and OutDoor show travel", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "DIA-Cancun/Puerto Vallarta nonstops, spring break, outdoor adventure tourism to Costa Rica and Belize", urgency: "Spring break bookings peak January through March; adventure trips 4–6 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Iceland & Nordics", context: "DIA-Reykjavik nonstop via Icelandair, adventure travelers en route to Europe, northern lights tourism", urgency: "Icelandair connections create last-minute European gateway scenarios", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Colorado Service Areas",
    crossLinksDesc: "We serve travelers across the Centennial State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Colorado Springs", route: "/colorado-springs" },
      { name: "Boulder", route: "/boulder" },
      { name: "Fort Collins", route: "/fort-collins" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Cherry Creek", address: "3000 E. 1st Ave, Denver, CO 80206", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Capitol Hill", address: "434 E. 8th Ave, Denver, CO 80203", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Downtown", address: "1600 Stout St, Denver, CO 80202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "UPS Store — Highlands", address: "3201 N. Zuni St, Denver, CO 80211", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Aurora", address: "3301 N. Tower Rd, Aurora, CO 80011", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Lakewood", address: "1000 S. Wadsworth Blvd, Lakewood, CO 80226", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Postal Annex — Westminster", address: "5454 W. 88th Ave, Westminster, CO 80020", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM", website: "https://www.postalannex.com/" },
    { name: "Costco — Thornton", address: "1500 W. 88th Ave, Thornton, CO 80260", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    {
      name: "DMV — Downtown Denver",
      address: "1865 W. Mississippi Ave, Denver, CO 80223",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Aurora",
      address: "14391 E. 4th Ave, Aurora, CO 80011",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Lakewood",
      address: "1881 Pierce St, Lakewood, CO 80214",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Westminster",
      address: "8450 N. Federal Blvd, Westminster, CO 80031",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center. Extended hours available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "25 miles from downtown Denver",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "America's largest airport by land area. United Airlines and Southwest hub with nonstop flights to 215+ destinations including Tokyo, London, Frankfurt, Reykjavik, and Mexico City. Primary international gateway for the entire Mountain West region.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "70 miles from Denver",
      address: "7770 Milton E. Proby Pkwy, Colorado Springs, CO 80916",
      note: "Regional airport with domestic flights and some international connections. Alternative for southern Colorado travelers.",
      flightUrl: "https://www.coloradosprings.gov/airport",
      flightLabel: "Colorado Springs Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Colorado Department of Public Health and Environment Vital Records. Online, mail, or in-person at Denver vital records office. Same-day service available for Denver County births.",
      url: "https://cdphe.colorado.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the Colorado Department of Public Health and Environment. Required for estate, legal, and survivor benefit matters.",
      url: "https://cdphe.colorado.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage records from the Denver Office of the Clerk and Recorder. Required for name change passport applications for Denver County marriages.",
      url: "https://www.denvergov.org/Government/Agencies-Departments-Offices/Agencies-Departments-Offices-Directory/Office-of-the-Clerk-and-Recorder",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Denver District Court. Required for name change passport corrections and legal documentation.",
      url: "https://www.courts.state.co.us/Courts/County/Index.cfm?County_ID=2",
    },
  ],
};